import {usePlatformServiceToken, useResourcesToken, useTrackingServiceToken} from '@/di/di.root-container.hooks';
import {AnalyticsFaqQuestionButtonType} from '@/services/TrackingService/TrackingService.constants';

import cn from 'classnames';

import {useUserStore} from '@/stores/connectors';
import {ButtonLink, ButtonLinkMods, ButtonLinkSize} from '@/ui/kit/ButtonLink/ButtonLink';
import {QRCode} from '@/ui/kit/QRCode/QRCode';

import s from './FindAppButton.module.css';

interface Props {
  className?: string;
}

export function FindAppButton({className}: Props): JSX.Element {
  const {text, qrCodeText, linkDefault, linkIos} = useResourcesToken().content.FindAppButton;
  const platformService = usePlatformServiceToken();
  const trackingService = useTrackingServiceToken();

  const userStore = useUserStore();
  const isLoggedIn = userStore.isLoggedIn();

  const isIos = platformService.detectIsIos();
  const link = isIos ? linkIos : linkDefault;

  return (
    <>
      <ButtonLink
        href={link}
        mod={ButtonLinkMods.ButtonPrimary}
        size={ButtonLinkSize.S}
        className={cn(s.link, className)}
        onClick={() => {
          if (isLoggedIn) {
            trackingService.trackClickToFaqQuestionButton(AnalyticsFaqQuestionButtonType.OpenInApp);
          } else {
            trackingService.trackClickToFindAppButton();
          }
        }}
      >
        {text}
      </ButtonLink>
      <QRCode qrCodeText={qrCodeText} url={link} className={cn(s.qrCode, className)} />
    </>
  );
}
